import "./settings.styles.css";

import "./notification.styles.scss";
import { Row, Col } from "antd";

import React, { useState, useRef, useEffect } from "react";
import {
  Toast,
  Button,
  Form,
  Input,
  Select,
  NotificationItem,
  appMap,
  typeMap,
  Icon,
  Tooltip,
  Quill,
} from "@alpaca/framework";
import { getPermissionGroupsService } from "../../../service/permission/permission";
import { addNotificationService } from "../../../service/notification/notification";
import { getAllApps } from "../../../service/app/version";
import { UserInfoSelector } from "../../../store/reduxSelector";
import Settings from "./settings.component";
import { useWatch } from "antd/es/form/Form";
export function NotificationSettings({ fetchNotification }) {
  const user = UserInfoSelector();
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [appOption, setAppOptions] = useState([]);
  const [sendToGroupOptions, setSendToGroupOptions] = useState([]);
  const toastRef = useRef(null);
  const [form] = Form.useForm();
  const notificationTitle = useWatch("title", form);
  const notificationApp = useWatch("app", form);
  const notificationType = useWatch("type", form);
  const notificationContent = useWatch("content", form);
  const notificationTypeOptions = [
    "info",
    "warning",
    "error",
    "success",
    "special",
  ];
  // when the quill editor changes, update the form value
  const handleQuillChange = (content) => {
    const text = content.replace(/<[^>]+>/g, "").trim();
    // If no characters, set as empty string
    form.setFieldsValue({ content: text.length === 0 ? "" : content });
  };
  useEffect(() => {
    const fetchOptionData = async () => {
      try {
        const appResult = await getAllApps();
        const permissionGroupResult = await getPermissionGroupsService();
        const permissionGroupOption = permissionGroupResult.map(
          (ele) => ele.permission_group_name
        );
        permissionGroupOption.unshift("All");
        setAppOptions(appResult);
        setSendToGroupOptions(permissionGroupOption);
      } catch (error) {
        toastRef.current.open({
          title: "Get App List/Permission Group fail",
          description: error.message,
          duration: 3,
          status: "error",
        });
      }
    };
    fetchOptionData();
  }, []);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const onSubmit = async (value) => {
    setLoading(true);
    try {
      await addNotificationService({
        company_name: user.company_name,
        ...value,
      });
      if (fetchNotification) {
        fetchNotification();
      }
      form.resetFields();
      //to do: refresh the notification list in the right section
    } catch (error) {
      toastRef.current.open({
        title: "Add notification Fail",
        description: error.message,
        duration: 3,
        status: "error",
      });
    }

    setLoading(false);
  };

  return (
    <div className="full-height">
      <Settings />
      <Toast ref={toastRef} />
      <div
        className={`notificationSectionContainer ${
          collapsed ? "collapsed" : ""
        }`}
      >
        <div
          className={`notificationDetailsContainer ${
            collapsed ? "collapsed" : ""
          }`}
        >
          <div className="head-btn-container">
            <div className="head-btn-subheader">
              <h2 className="sectionHeading">Add Notification</h2>
              <p className="bodyTextSmall">
                Create alerts to send to your users.
              </p>
            </div>
            <Button onClick={toggleCollapsed} size="large">
              {collapsed ? "Expand Preview" : "Collapse Preview"}
            </Button>
          </div>

          <Form form={form} onFinish={onSubmit}>
            {/* Row 1 */}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="title"
                  label="Notification Title"
                  labelCol={{ span: 24 }}
                  rules={[{ required: true, message: "Please enter title" }]}
                >
                  <Input
                    title="Title"
                    required
                    size="large"
                    placeholder="Notification Title"
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="type"
                  label="Type"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select type of notification",
                    },
                  ]}
                >
                  <Select
                    title="Type"
                    className="user-input capitalize-inputs"
                    required
                    size="large"
                    placeholder="Please Select"
                  >
                    {notificationTypeOptions.map((option) => (
                      <Select.Option
                        key={option}
                        value={option}
                        className="capitalize-inputs"
                      >
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Row 2 */}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="app"
                  label="App"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message:
                        "Please select which app can see this notification",
                    },
                  ]}
                >
                  <Select
                    title="App"
                    className="user-input"
                    required
                    size="large"
                    placeholder="Please Select"
                  >
                    {appOption.map((option) => (
                      <Select.Option
                        key={option.app_name}
                        value={option.app_name}
                      >
                        {option.app_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="group"
                  label="Send To"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message:
                        "Please select which user group will receive this notification",
                    },
                  ]}
                >
                  <Select
                    title="Send To"
                    className="user-input"
                    required
                    size="large"
                    placeholder="Please Select"
                  >
                    {sendToGroupOptions.map((option) => (
                      <Select.Option key={option} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Full width row */}
            <Row>
              <Col span={24}>
                <Form.Item
                  name="content"
                  label="Notification Content"
                  labelCol={{ span: 24 }}
                  rules={[{ required: true, message: "Content is required" }]}
                >
                  <Quill
                    theme="snow"
                    value={form.getFieldValue("content")}
                    onChange={handleQuillChange}
                    style={{ minHeight: 150 }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <Button
            onClick={() => form.submit()}
            loading={loading}
            type="primary"
            size="large"
          >
            Submit
          </Button>
        </div>

        <div
          className={`notificationPreviewContainer ${
            collapsed ? "collapsed" : ""
          }`}
        >
          <NotificationItem
            notification={{
              subject: notificationTitle,
              content: notificationContent,
              app_name: notificationApp,
              notification_type: notificationType,
            }}
            className={typeMap[notificationType]?.className || ""}
            appIcon={appMap[notificationApp] || ""}
            statusIcon={typeMap[notificationType]?.icon || ""}
          />
        </div>
      </div>
    </div>
  );
}

export default NotificationSettings;
